<div class="mat-dialog-content message">
  <span class="message-icon tone-{{ icon }}">
    <mat-icon class="{{ 'icon-' + icon }}">{{ icon }}</mat-icon>
  </span>
  <h2 class="message-title">{{ title }}</h2>
  <p class="message-text" [innerHTML]="message"></p>
</div>

<div mat-dialog-actions align="center">
  <button mat-flat-button color="{{ iconColor }}" (click)="onDismiss()" tabindex="-1">OK</button>
</div>
